import React from 'react'
import { Checkbox, Input } from 'antd'
import { ProductInfo } from '../types'

interface MenuDropdownProps {
  searchQuery?: string
  onSearchChange: (value: string) => void
  values?: string[]
  options?: ProductInfo[]
  isMulti?: boolean
  onChange: (values: string[]) => void
  maxWidth?: number
}

const MenuDropdown: React.FC<MenuDropdownProps> = ({
  searchQuery,
  onSearchChange,
  values,
  options,
  isMulti,
  onChange,
  maxWidth
}) => {
  return (
    <div
      style={{
        minHeight: 'fit-content',
        width: maxWidth || 208,
        maxHeight: 400,
        overflow: 'scroll',
      }}
      className="CommonInputs-multi-select-dropdown flex flex-col bg-gray_1 p-2 customer-segments-filter-dropdown"
    >
      <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
        <Input
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          style={{ flex: 1 }}
        />
      </div>

      {values?.length ? (
        <div style={{ marginBottom: '8px' }}>
          {(Array?.isArray(values) ? values : [values])?.map((item, index) => {
            return (
              <div
                className="cursor-pointer p-2 pl-4 bg-blue_1"
                key={`${item}-${index}`}
                onClick={() => {
                  const newList = values?.filter((v) => v !== item)
                  onChange(newList)
                }}
              >
                {item}
              </div>
            )
          })}
        </div>
      ) : null}

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {options?.map((option) => (
          <Checkbox
            style={{
              margin: 0,
            }}
            checked={values?.includes(option.value)}
            onChange={(e) => {
              const isSelected = values?.includes(option.value)
              if (!isMulti) {
                onChange(isSelected ? [] : [option.value])
                return
              }

              const newList = isSelected
                ? values?.filter((item) => item !== option.value) || []
                : [...(values || []), option.value]
              onChange(newList)
            }}
            value={option.value}
            key={option.value}
          >
            {option.label}
          </Checkbox>
        ))}
      </div>
    </div>
  )
}

export default MenuDropdown 